import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import OfficeService from '../../../Services/OfficeService';

// Trivial placeholder: the wizard only instantiates windowDescription.itemType when no
// editedItem prop is passed. OfficeAdmin always passes the selected office (crudType=Update),
// so this is never invoked, but it keeps the windowDescription contract satisfied.
class OfficeContactEditItem {}

export default class EditOfficeContactWindowDescription {
  static titleForEdit = (item) => `Edit Office Contact Information (${item.Name})`;
  static itemType = OfficeContactEditItem;
  static finishButtonLabel = 'Save Office';
  static messageOnSuccess = 'Office has been saved.';

  // Mirrors the old panel's clickOnSubmitButton: the whole edited office object is posted back
  // (OfficeService.EditOffice string-converts and PUTs the entire office). MUST return the
  // promise (wizard contract).
  static serviceFunction = (edited) => OfficeService.EditOffice(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'AddressOfficeLegalName',
          label: 'Office Legal Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AddressCountryId',
          label: 'Country',
          className: 'col-6',
          type: InputTypesEnum.CountrySelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AddressState',
          label: 'State',
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AddressCity',
          label: 'City',
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AddressPostalCode',
          label: 'Postal Code',
          className: 'col-4',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'AddressStreet',
          label: 'Street',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'PhoneNumber',
          label: 'Phone',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'FaxNumber',
          label: 'Fax Number',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
